// helpers/auth.js
import { jwtDecode } from 'jwt-decode';

// Function to get the Authorization header with the token
export const getAuthHeader = () => {
    const token = localStorage.getItem('token');
    return {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };
  };
  
  // Function to check if the user is logged in
  export const isAuthenticated = () => {
    const token = localStorage.getItem('token');
    return token !== null; // If token exists, user is authenticated
  };
  
  // Function to save token to localStorage
  export const setAuthToken = (token) => {
    localStorage.setItem('token', token);
  };
  
  // Function to remove token from localStorage (e.g., on logout)
  export const removeAuthToken = () => {
    localStorage.removeItem('token');
  };
  export const getUserIdFromToken = () => {
    const token = localStorage.getItem('token');
    if (!token) return null;
  
    try {
      const decoded = jwtDecode(token);
      return decoded.user_id;
    } catch (error) {
      console.error('Invalid token:', error);
      return null;
    }
  }
  
  